var englishTranslations = {
    translation: {
        actions: {
            cancel: "Cancel",
            openTab: "Open Tab",
            close: "Close",
        },
        labels: {
            title: "Credit Score",
            findingYourAccount: "Finding Your Account",
        },
        unenrollModal: {
            title: "Are you sure you want to unenroll in Your Credit Score?",
            body: "If you unenroll, your existing score history will no longer be available for you to view. However, you can re-enroll later.",
            stayEnrolled: "Keep me enrolled",
            unenroll: "Unenroll me",
        },
        unenrollSuccessModal: {
            title: "You've been unenrolled in Your Credit Score",
            body: "You can re-enroll at anytime in the profile menu.",
        },
        creditStatus: {
            excellent: "Excellent",
            veryGood: "Very Good",
            good: "Good",
            fair: "Fair",
            poor: "Poor",
        },
        creditToolTip: {
            whatDoesCreditScoreMean: "What does Your Credit Score mean?",
            excellentTitle: "<strong> 781 - 850: Excellent - </strong><em>40% of the population</em> <br/>",
            excellentBody: "Will typically get the best interest rates possible",
            veryGoodTitle: " <strong> 720 - 780: Very Good - </strong><em>20% of the population</em> <br/>",
            veryGoodBody: " Will usually be approved almost anywhere with good rates",
            goodTitle: "<strong> 658 - 719: Good - </strong><em>17% of the population</em> <br/>",
            goodBody: "Will likely be approved with good rates",
            fairTitle: "<strong> 601 - 657: Fair - </strong> <em>14% of the population</em> <br/>",
            fairBody: "Will be given a loan, but will have high interest rate",
            poorTitle: "<strong> 300 - 600: Poor - </strong><em>9% of the population</em> <br/>",
            poorBody: "Will only be given a secured loan",
        },
        crossBorderText: "The information shared at this link is not part of Synchrony Bank. Please note that because this site you are going to is not controlled by Synchrony Bank, you will be subject to the terms of use and privacy policy of the website you are visiting.",
        creditScorePage: {
            headerSection: {
                updatedOn: "Updated on",
                creditScoreInfo: "Your Credit Score has been updated and now reflects your current credit score and history with an updated VantageScore 4.0 model. <strong> For any questions regarding your VantageScore Credit Score, please contact TransUnion LLC at </strong> <link1>(866) 215-1713. </link1>",
                creditScore: "Your Credit Score",
                score: "Your Score",
            },
            buttons: {
                problemWithScore: "See a problem with your score?",
            },
            problemWithScore: {
                questionsAboutCreditScore: "Questions about Your Credit Score?",
                aboutCreditScoreAndReasonCodes: "Your Credit Score and Reason Codes are provided to Synchrony Bank and reflect the information contained within your TransUnion credit report based on the calculation date (i.e. “as of” date).",
                followStepsText: "<strong>If you feel this information is inaccurate, you can take these steps:</strong>",
                stepOne: "Request a free annual credit report from TransUnion at <annualCreditLink>www.annualcreditreport.com</annualCreditLink>",
                stepTwo: "Review your report",
                stepThree: "If you find inaccurate information, <strong>contact TransUnion</strong> at <transUnionLink>dispute.transunion.com</transUnionLink> or call <transUnionPhoneNumber>(800) 916-8800</transUnionPhoneNumber>",
                closeBtnText: "Close",
            },
            links: {
                learnMore: "Learn more about improving your credit score",
                unenroll: "Unenroll in Your Credit Score",
            },
            headers: {
                affect: "What's affecting your credit score",
                influences: "What influences your credit score",
                tips: "Top 10 tips to improve your credit score",
            },
            tipColumnOne: [
                "<strong>Always</strong> pay on time",
                "Pay <strong>at least the minimum</strong> due amount",
                "Pay <strong>as much as you can</strong> each month",
                "Pay off your card <strong> in full each month </strong>",
                "<strong> Set up text or email alerts</strong> to notify you of your balance and due date",
                "Set up <strong>automatic payments</strong>",
            ],
            tipColumnTwo: [
                "Only use <strong>30-40% </strong> of your credit limit",
                "Monitor your credit report and <strong>correct any inaccuracies</strong>",
                "Apply for new credit <strong>in moderation</strong>",
                "Establish a <strong>long history of paying on time</strong> and using credit responsibly",
            ],
            tipModal: {
                summary: "Having good credit means you have a <strong>record of paying your bills on time</strong>. It means you've shown <strong>you know how to manage your credit</strong>. Good credit may help you get better <strong>access to certain loans and credit cards</strong> and typically, lower interest rates too.",
            },
            influences: [
                {
                    color: "#C42D1E",
                    influenceType: "EXTREMELY INFLUENTIAL",
                    header: "Too many bankcards with a high balance",
                    body: "Focus on keeping revolving balance low, under 30% of credit limits.",
                },
                {
                    color: "#AC5600",
                    influenceType: "HIGHLY INFLUENTIAL",
                    header: "Credit Mix and Experience",
                    body: "It's helpful to maintain a mix of accounts (credit cards, auto, mortgage) over time to improve your score.",
                },
                {
                    color: "#CAA416",
                    influenceType: "MODERATELY INFLUENTIAL",
                    header: "Payment History",
                    body: "Make sure you pay all bills on time",
                },
                {
                    color: "#2B5C1D",
                    influenceType: "LESS INFLUENTIAL",
                    header: "Age of Credit History",
                    body: "Higher-scoring consumers have credit open accounts such as credit cards in good standing for longer periods of time. Don't close your older accounts.",
                },
                {
                    color: "#2B5C1D",
                    influenceType: "LESS INFLUENTIAL",
                    header: "New Accounts",
                    body: "Don't open too many new accounts too quickly.",
                },
            ],
            disclaimers: {
                thirdParty: "This information has been provided by a third party, and Synchrony bank has no responsibility for the content provided. The content provided is intended for the primary cardholder only. You may unenroll at any time. This program is subject to change.",
                transUnion: 'Your Credit Score and Reason Codes are provided to Synchrony Bank and reflect the information contained within your TransUnion® credit report based on the calculation date (i.e. "as of" date). <strong>If you feel this information is inaccurate</strong>, you can request a free annual credit report from TransUnion® at <link1>www.annualcreditreport.com.</link1> After reviewing your report, if you find inacurrate information you can dispute your TransUnion® credit report at <link2>https://dispute.transunion.com</link2> or call TransUnion® at (800) 916-8800.',
                creditRepair: '<strong> Synchrony Bank is not a credit repair organization </strong> as defined under federal and state law, including the Credit Repair Organizations Act. <strong>  Synchrony Bank does not provide "credit repair" services or advice or assistance regarding "rebuilding" or "improving" your credit record, credit history or credit rating.</strong>',
            },
            unenroll: {
                areYouSure: "Are you sure you want to unenroll in Your Credit Score?",
                ifYouUnenroll: "If you unenroll, your existing score history will no longer be available for you to view.  However, you can re-enroll later.",
                keepMeEnrolled: "Keep me enrolled",
                unenrollMe: "Unenroll me",
                youHaveBeenUnenrolled: "You've been unenrolled in Your Credit Score",
                youCanReEnroll: "You can re-enroll at anytime in the profile menu.",
            },
        },
        noCreditScorePage: {
            headerSection: {
                getYouCreditScoreToday: "Get Your Free Monthly Credit Score Today",
            },
            bodySection: {
                subtitle: "You can get access to Your Credit Score just by having an open Synchrony Bank account",
                benefits: {
                    transUnion: "See Your VantageScore Credit Score by TransUnion, updated monthly",
                    influences: "Find out what influences your credit score the most",
                    trackCreditScore: "Track your credit score over time",
                    improveCreditScore: "Learn how to help improve your credit score",
                },
                enrollMeButton: "Enroll Me Now",
                agreement: 'By clicking "Enroll Me Now", you agree that Synchrony Bank may request information from consumer reporting agencies to fulfill this program and any successor free credit score program. You understand that the information is currently provided by TransUnion, a third party and that Synchrony Bank have no responsibility for the content provided. Scores are available online only to primary cardmembers with an open account. You may unenroll at any time. This program is subject to change.',
            },
        },
        errorPage: {
            anyAccountsQualify: "You don't have any open accounts that qualify for Your Credit Score.",
            creditScoreNotAvailable: "Your Credit Score is not currently\navailable",
            mobileTitle: "We Apologize",
            title: "We are having technical trouble",
            description: "Please try again later.",
            subTitle: "We are currently experiencing technical difficulties and are unable to access Your Credit Score.",
            accountManager: "Account Manager",
        },
    },
};
export default englishTranslations;
